import React from "react"
import { useNavigate } from "react-router"
import useTitle from "@/hooks/useTitle"
import { useGetQuestionsQuery } from "./questionsApiSlice"
import { addIcon, editIcon, deleteIcon } from "@/assets/img/imgAssets"
import PulseLoader from "react-spinners/PulseLoader"

const EtQuestionList = ({setActiveAdminView, onAdd, onUpdate, onDelete, setSelectedEntityId }) => {
  // First Created - 04 Apr 2024
  // Author - Atul Pandey
  // Updated - 28 Feb 2025 - updated the softSkillFunctionArea with props - { setActiveAdminView, onAdd, onUpdate, onDelete, setSelectedEntityId }
  // Updated - 28 Feb 2025 - switched from navigate to onAdd, onUpdate, onDelete, setSelectedEntityId

  // 1 - Navigate
  const navigate = useNavigate()
  
  // 2 - Use Title
  useTitle("Question List")
  
  // 3 - Use the RTK Query hook to get question sets
  const { data: questions, isError, error, isLoading } = useGetQuestionsQuery()
  console.log("questions:", questions)

  // 4 - Optional: handle loading and error states
  if (isLoading) return <PulseLoader color={"#ea580c"} />
  if (isError) return <div>Error occurred: {error?.data?.message}</div>

  // 5 - Create an object for setting inner HTML
  const createMarkup = (htmlContent) => {
    return { __html: htmlContent }
  }

  return (
    <div className=" bg-gray-200 p-1 mx-auto my-5 rounded-lg shadow-md shadow-black">
      <div className="flex justify-start items-center p-1 m-1">
        <div>
          <p className="p-1 m-2 font-bold font-poppins text-xl">Questions</p>
        </div>
        <div>
          <img
            src={addIcon}
            alt=""
            className="h-10 w-10 cursor-pointer"
            // onClick={() => navigate("/admin/questions/create")}
            onClick={onAdd} // 28 Feb 2025
          />
        </div>
      </div>
      {/* Header */}
      <div
        id="header"
        className="grid grid-cols-8 space-x-2 mx-3 my-1 px-1 py-3 text-black font-bold rounded bg-gradient-to-r from-orange-600 to-orange-600 via-orange-400 shadow-md shadow-black"
      >
        <div className="col-span-1 flex justify-start">
          
        </div>

        <div className="col-span-1">
          <p className="font-poppins text-xs text-left px-2">Set Name</p>
        </div>
        <div className="col-span-2">
          <p className="font-poppins text-xs text-left px-2">Question</p>
        </div>
        <div className="col-span-2">
          <p className="font-poppins text-xs text-left px-2">Sub Text</p>
        </div>
        <div className="col-span-2">
          <p className="font-poppins text-xs text-left px-2">Hint Text</p>
        </div>
      </div>

      {/* Data */}

      {questions &&
        questions.ids.map((id) => {
          const { qsetName, questionName, questionSubText, questionHintText } =
            questions.entities[id]
          return (
            <div
              id="data"
              className="grid grid-cols-8 space-x-2 mx-3 my-1 px-1 py-3 bg-white rounded items-center"
            >
              <div className="col-span-1 flex justify-start">
                <img src={editIcon} alt="" className="h-6 w-6 p-1 m-1 cursor-pointer" 
                
                // onClick={() => navigate(`/admin/questions/update/${id}`)}
                onClick={() => onUpdate(id)} // 28 Feb 2025 
                
                />
                
                <img src={deleteIcon} alt="" className="h-6 w-6 p-1 m-1 cursor-pointer" 
                
                // onClick={() => navigate(`/admin/questions/delete/${id}`)} 
                onClick={() => onDelete(id)} // 28 Feb 2025 
                
                />
              </div>
              <div className="col-span-1">
                <p className="font-poppins text-xs text-left px-2">
                  {qsetName}
                </p>
              </div>
              <div
                className="col-span-2 font-poppins text-xs text-left px-2"
                dangerouslySetInnerHTML={createMarkup(questionName)}
              ></div>
              <div className="col-span-2">
                <p className="font-poppins text-xs text-left px-2">
                  {questionSubText}
                </p>{" "}
              </div>
              <div className="col-span-2">
                <p className="font-poppins text-xs text-left px-2">
                  {questionHintText}
                </p>
              </div>
            </div>
          )
        })}
    </div>
  )
}

export default EtQuestionList
